import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  InsuranceAgreementFilterStatus,
  InsuranceAgreementSortColumn,
  SortOrder,
} from 'api/insurance'
import { RootState } from 'appHooks'
import { IPaginationModel } from 'shared/models/List'

export type InsuranceAgreementsListFilters = IPaginationModel & {
  searchText?: string
  sortOrder: SortOrder
  sortColumn: InsuranceAgreementSortColumn
  contractStatus: InsuranceAgreementFilterStatus
  isBoardPortal: boolean
}

export const insuranceAgreementsInitialFilters: InsuranceAgreementsListFilters =
  {
    contractStatus: InsuranceAgreementFilterStatus.Active,
    sortColumn: InsuranceAgreementSortColumn.IsMainPolicy,
    sortOrder: SortOrder.Descending,
    take: 10,
    skip: 0,
    isBoardPortal: true,
  }

const insuranceAgreementsFiltersSlice = createSlice({
  name: 'insuranceAgreementsFilters',
  initialState: insuranceAgreementsInitialFilters,
  reducers: {
    patchInsuranceAgreementsFilters: (
      state,
      action: PayloadAction<Partial<InsuranceAgreementsListFilters>>
    ) => ({ ...state, ...action.payload }),
    resetInsuranceAgreementsFilters: () => insuranceAgreementsInitialFilters,
  },
})

export const getInsuranceAgreementsFilters = (state: RootState) =>
  state.insuranceAgreementsFilters

export const {
  patchInsuranceAgreementsFilters,
  resetInsuranceAgreementsFilters,
} = insuranceAgreementsFiltersSlice.actions

export default insuranceAgreementsFiltersSlice
